import styled from 'styled-components';

import { Form } from '@dreryk/react-components';

export const StyledPatientAddressForm = styled(Form)`
   display: grid;
   grid-template-columns: 308px repeat(2, 126px);
   grid-template-rows: repeat(3, 1fr);
   grid-column-gap: 36px;
   grid-row-gap: 12px;
`;
